<template>
  <div class="products-page">
    <Nav />
    <section class="hero" ref="hero">
      <div class="hero-content">
        <h1 class="ani-top">BUILDING THE CHEMICAL SUPPLY CHAIN FOR PU,PVC AND EVA INDUSTRIAL PRODUCTS!</h1>
        <p class="ani-bottom">QINYUAN GROUP provides innovative, customizable chemical raw material relative to
          PU,PVC,EVA serious. offering comfort, durability, and eco-friendly solutions tailored to various applications
          like footwear, synthetic leather, rigid PU,soft pu foam, plsticsizer,adhesive and EVA sheet.</p>
      </div>
      <div class="hero-bg">
        <img src="@/assets/banner.jpg" alt="PU PVC EVA Industrial Chemical Raw Materials Business Banner">
      </div>
    </section>
    <section class="products-section" ref="productSection">
      <div class="container">
        <div class="product-card ani-left">
          <div class="product-image ani-scale">
            <img src="@/assets/banner.jpg" alt="Polyurethane Series Chemical Raw Materials Industrial Supplies">
          </div>
          <div class="product-text ani-right">
            <h2>RAW MATERIAL RELATIVE TO POLYURETHANE</h2>
            <p>WE PROVIDE ALL KINDS OF CHEMICAL RAW MATERIAL RELATIVE TO POLYURETHANE INDUSTRIAL. LIKE PUR MDI, ADPIC
              ACID, PIA,TMP,PA,POLYESTER POLY, POLYETHER POLY,CATALYST, SILICON SURFACTANT. POP POLY.</p>
            <h4>Applications:</h4>
            <ul>
              <li>PU SYSTEM MATERIAL PRODUCER</li>
            </ul>
            <button class="btn-primary" @click="$router.push('/careers')">Learn More</button>
          </div>
        </div>
        <div class="product-card reverse ani-right">
          <div class="product-image ani-scale">
            <img src="@/assets/banner.jpg" alt="Synthetic Leather Production Raw Materials Accessories">
          </div>
          <div class="product-text ani-left">
            <h2>RAW MATERIAL RELATIVE TO SYNTHETIC LEATHER</h2>
            <p>WE PROVIDE DIFFERENT KINDS OF RAW MATERIAL FOR SYNTHETIC LEATHER LIKE <br>
              PU RESIN FOR DRY AND WET PROCESS, PU FINISHING LACQUER, PVC PASTE RESIN, DMF,MEK,TOL, DOP, DOTP, DOA,
              AZODICARBONAMIDE,STABLIZER,COLOR PIGMENT, COLOR PASTE,WOOD POWDER FILLER, RELEASE PAPER, JOIN TAPES,
              VACUUM ROLLER, PRINTING MESH ROLLER, TRANSFER FOIL.
            </p>
            <h4>Applications:</h4>
            <ul>
              <li>PU SYNTHETIC LEATHER PRODUCER</li>
              <li> PVC SYNTHETIC LEATHER PRODUCER</li>
              <li> MICRO FIBER SYNTHETIC LEATHER PRODUCER</li>
            </ul>
            <button class="btn-primary" @click="$router.push('/careers')">Learn More</button>
          </div>
        </div>
        <div class="product-card ani-left">
          <div class="product-image ani-scale">
            <img src="@/assets/banner.jpg" alt="Footwear Making Raw Materials Shoe Industry Accessories">
          </div>
          <div class="product-text ani-right">
            <h2>RAW MATERIAL RELATIVE TO FOOTWEAR </h2>
            <p>WE PROVIDE RAW MATERIAL FOR DIFFERENT KINDS OF SHOES LIKE <br>
              SHOE UPPER, PU RESIN FOR SHOES, COLOR PIGMENT OR PASTE,RELEASE AGENT WATER BASED OR SOLVENT BASED, PVC
              COMPOUNDING FOR INJECTION SHOES ,ADDTIVES, thermoplastic polyurethane elastomer（TPU）, EVA COMPOUNDING,PU
              ADHESIVE FOR SHOES.
            </p>
            <h4>Applications:</h4>
            <ul>
              <li>PU SHOES MAKER </li>
              <li> PVC SHOES MAKER </li>
              <li>EVA SHOES MAKER </li>
            </ul>
            <button class="btn-primary" @click="$router.push('/careers')">Learn More</button>
          </div>
        </div>
        <div class="product-card reverse ani-right">
          <div class="product-image ani-scale">
            <img src="@/assets/banner.jpg" alt="Plasticizer Industrial Raw Materials Chemical Supplies">
          </div>
          <div class="product-text ani-left">
            <h2>RAW MATERIAL RELATIVE TO PLASTICIZER</h2>
            <p>we provide raw material for plasticizer like 2EH, TIPT,TEHT,2EH ACID. ADPIC ACID.
            </p>
            <h4>Applications:</h4>
            <ul>
              <li>DOP/DOTP PLASTICIZER MAKER </li>
            </ul>
            <button class="btn-primary" @click="$router.push('/careers')">Learn More</button>
          </div>
        </div>
        <div class="product-card ani-left">
          <div class="product-image ani-scale">
            <img src="@/assets/banner.jpg" alt="Industrial Production Machine For PU PVC Leather Industry">
          </div>
          <div class="product-text ani-right">
            <h2>MACHINES </h2>
            <p>REACTORS FOR PU AND DOP<br>
              COATING MACHINE FOR SYNTHETIC LEATHER <br>
              CANLENDER MACHINE FOR SYNTHETIC LEATHER <br>
              MACHINES FOR MICRO FIBER LEATHER
            </p>
            <h4>Applications:</h4>
            <ul>
              <li>PU MAKER</li>
              <li> PLASTICIZER MAKER</li>
              <li> SYNTHETIC LEATHER MAKER </li>
            </ul>
            <button class="btn-primary" @click="$router.push('/careers')">Learn More</button>
          </div>
        </div>
      </div>
    </section>
    <section class="certificates" ref="certificates">
      <div class="container">
        <div class="cert-carousel-wrap">
          <div class="certificates-grid">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
            <img src="@/assets/banner.jpg" alt="Company Qualification Certificate International Trade Certification"
              class="cert-img">
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
export default {
  name: "ProductsPage",
  // 新增页面独立SEO标题、描述、关键词
  head() {
    return {
      title:
        "QINYUAN GROUP | PU PVC EVA Chemical Raw Materials & Industrial Machinery Supplier",
      meta: [
        {
          name: "description",
          content:
            "QINYUAN GROUP is a professional supplier founded in 2013, mainly supplying polyurethane, PVC, EVA series chemical raw materials, synthetic leather materials, footwear raw materials, plasticizer raw materials and matching industrial production machines. We provide one-stop raw material supply and technical service, products widely used in synthetic leather, shoes, foam materials and other fields, exported to more than 20 countries around the world.",
        },
        {
          name: "keywords",
          content:
            "PU chemical raw materials, PVC industrial raw materials, EVA copolymer materials, synthetic leather raw materials, shoe making materials, plasticizer raw materials, industrial production machinery, polyurethane accessories, global chemical material supply, one-stop industrial service",
        },
      ],
    };
  },
  mounted() {
    this.initScrollAnimation();
    document.title =
      "PRODUCTS | PU PVC EVA Chemical Raw Materials & Industrial Machinery Supplier";
  },
  methods: {
    initScrollAnimation() {
      const sections = [
        this.$refs.hero,
        this.$refs.productSection,
        this.$refs.certificates,
      ];
      const handleScroll = () => {
        sections.forEach((section) => {
          if (!section) return;
          const rect = section.getBoundingClientRect();
          const isInView =
            rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
          if (isInView) section.classList.add("active");
        });
      };
      window.addEventListener("scroll", handleScroll);
      handleScroll();
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("scroll", handleScroll);
      });
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
}
.products-page {
  overflow-x: hidden;
}
.hero {
  background: transparent;
  color: #fff;
  padding: 0;
  height: 480px;
  position: relative;
  overflow: hidden;
}
.hero .hero-content {
  position: absolute;
  top: 50%;
  left: 224px;
  transform: translateY(-50%);
  max-width: 45%;
  z-index: 2;
}
.hero .hero-content h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.3;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.hero .hero-content p {
  font-size: 1.1rem;
  opacity: 0.9;
}
.hero .hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.hero .hero-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hero::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(
    90deg,
    #c91d22 0%,
    #c91d22 40%,
    rgba(201, 29, 34, 0) 100%
  );
  z-index: 1;
}
.products-section {
  padding: 4rem 0;
}
.products-section .product-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: dense;
  gap: 3rem;
  align-items: center;
  background: #fff;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  margin-bottom: 4rem;
  transition: transform 0.3s, box-shadow 0.3s;
}
.products-section .product-card .product-image {
  grid-column: 1 / 2;
}
.products-section .product-card .product-text {
  grid-column: 2 / 3;
}
.products-section .product-card.reverse .product-image {
  grid-column: 2 / 3;
}
.products-section .product-card.reverse .product-text {
  grid-column: 1 / 2;
}
.products-section .product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}
.products-section .product-card .product-text h2 {
  color: #d81f26;
  font-size: 2rem;
  margin-bottom: 1rem;
  font-weight: 700;
}
.products-section .product-card .product-text h4 {
  color: #333;
  margin: 1.5rem 0 0.5rem;
  font-weight: 600;
}
.products-section .product-card .product-text ul {
  list-style: disc;
  padding-left: 1.5rem;
  margin-bottom: 1.5rem;
}
.products-section .product-card .product-text ul li {
  margin-bottom: 0.3rem;
  list-style-type: disc;
}
.products-section .product-card .product-text .btn-primary {
  background: #d81f26;
  color: #fff;
  border: none;
  padding: 0.8rem 1.8rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  transition: background 0.3s;
}
.products-section .product-card .product-text .btn-primary:hover {
  background: #b81a20;
}
.products-section .product-card .product-image {
  width: 100%;
  height: auto;
}
.products-section .product-card .product-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}
.products-section .product-card .product-image img:hover {
  transform: scale(1.02);
}
.certificates {
  padding: 4rem 0;
  margin: -30px 0 30px 0;
  background-color: #f8f8f8;
  overflow: hidden;
}
.cert-carousel-wrap {
  width: 100%;
  overflow: hidden;
  position: relative;
}
.certificates-grid {
  display: flex;
  gap: 2rem;
  animation: certScroll 25s linear infinite;
  width: 200%;
}
.cert-carousel-wrap:hover .certificates-grid {
  animation-play-state: paused;
}
.cert-img {
  width: 300px;
  height: auto;
  flex-shrink: 0;
  border-radius: 6px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}
.cert-img:hover {
  transform: scale(1.02);
}
@keyframes certScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
.ani-top,
.ani-bottom,
.ani-left,
.ani-right,
.ani-scale {
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform, opacity;
}
.ani-top {
  transform: translateY(-60px);
}
.ani-bottom {
  transform: translateY(60px);
}
.ani-left {
  transform: translateX(-80px);
}
.ani-right {
  transform: translateX(80px);
}
.ani-scale {
  transform: scale(0.85);
}
.active .ani-top,
.active .ani-bottom,
.active .ani-left,
.active .ani-right {
  opacity: 1;
  transform: translate(0);
}
.active .ani-scale {
  opacity: 1;
  transform: scale(1);
}
.product-card .ani-scale {
  animation-delay: 0.2s;
}
.product-card .ani-left,
.product-card .ani-right {
  animation-delay: 0.3s;
}

/* 新增移动端适配 无改动原有样式 */
@media screen and (max-width: 1200px) {
  .hero .hero-content h1 {
    font-size: 2rem;
  }
  .products-section .product-card {
    padding: 2rem;
    gap: 2rem;
  }
}
@media screen and (max-width: 768px) {
  .hero {
    height: 360px;
  }
  .hero .hero-content {
    left: 30px;
    max-width: 80%;
  }
  .hero .hero-content h1 {
    font-size: 1.6rem;
  }
  .products-section .product-card {
    grid-template-columns: 1fr;
  }
  .products-section .product-card .product-image,
  .products-section .product-card .product-text,
  .products-section .product-card.reverse .product-image,
  .products-section .product-card.reverse .product-text {
    grid-column: 1/-1;
  }
  .container {
    padding: 0 20px;
  }
  .cert-img {
    width: 200px;
  }
}
</style>